<template>
	<div class="by-CriticalQuestions">
		<div
			ref="byCriticalQuestions"
			style="width: 100%; height: 100%; overflow: hidden"
		></div>
	</div>
</template>

<script>
import * as eCharts from "echarts";

export default {
	name: "byCriticalQuestions",
	props: {
		criticalQuestionsData: {
			type: Array,
			required: true,
		},
		showGraphbyCriticalQuestion: {
			type: Boolean,
			required: true,
		},
		showCompletion: {
			type: Boolean,
			default: false,
		},
		showScore: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		showGraphbyCriticalQuestion(val) {
			if (val) {
				this.initGraph();
			}
		},
	},
	mounted() {
		if (this.showGraphbyCriticalQuestion && this.criticalQuestionsData.length) {
			this.initGraph();
		}
	},
	data() {
		return {
			byCriticalQuestionsGraphInstance: null,
			option: {
				dataZoom: [
					{
						show: false,
						startValue: 0,
						endValue: 8,
						height: 20,
						zoomLock: true,
						zoomOnMouseWheel: false,
						moveOnMouseMove: false,
						moveOnMouseWheel: true,
						preventDefaultMouseMove: true,
					},
					{
						height: 15,
						type: "slider",
						startValue: 0,
						endValue: 100,
						zoomLock: true,
						labelFormatter: "",
						moveOnMouseWheel: true,
					},
					{
						show: false,
						yAxisIndex: 0,
						filterMode: "empty",
						width: 30,
						height: "100%",
						showDataShadow: false,
						zoomLock: true,
						left: "93%",
					},
				],
				color: ["#B22222"],
				tooltip: {
					trigger: "axis",
					axisPointer: {
						type: "shadow",
					},
					formatter: (p) => {
						return `${this.getDataByRegion(p[0].axisValue)}`;
					},
				},
				grid: {
					right: "10%",
					containLabel: true,
					borderColor: "#000000",
				},
				legend: {
					data: [],
					textStyle: {
						fontSize: 13,
					},
				},
				xAxis: [
					{
						type: "category",
						axisTick: {
							alignWithLabel: true,
						},
						axisLabel: {
							interval: 0,
							rotate: 37,
							overflow: "truncate",
							margin: 8,
							hideOverlap: true,
							align: "right",
							verticalAlign: "top",
							lineHeight: 6,
							formatter: (value) => {
								if (value.includes("__")) {
									let labelArr = value.split("__");
									return `${this.excerptText(
										this.titleCase(labelArr[0]),
										15
									)}\n${this.excerptText(this.titleCase(labelArr[1]), 15)}`;
								} else {
									return this.excerptText(value, 15);
								}
							},
						},
						boundaryGap: true,
						data: [],
						textStyle: {
							fontSize: 14,
						},
					},
				],
				yAxis: [
					{
						type: "value",
						position: "left",
						alignTicks: false,
						axisLine: {
							show: false,
						},
						axisLabel: {
							formatter: "{value}",
						},
					},
				],
				series: [
					{
						label: {
							normal: {
								show: true,
								position: "top",
								fontSize: 9,
								color: "#000000",
								formatter: "{c}",
							},
						},
						type: "bar",
						barGap: "10%",
						barCategoryGap: "10%",
						yAxisIndex: 0,
						barWidth: "24%",
						data: [],
						showBackground: false,
						itemStyle: {
							normal: {
								barBorderRadius: [0, 0, 0, 0],
							},
						},
					},
				],
			},
		};
	},
	methods: {
		excerptText(text, length = 10, clamp = "...") {
			return text.length > length
				? text.toString().slice(0, length) + clamp
				: text;
		},
		titleCase(str) {
			return str
				.toLowerCase()
				.split(" ")
				.map((word) => this.capitalizeFirstLetter(word))
				.join(" ");
		},
		capitalizeFirstLetter(word) {
			return word.charAt(0).toUpperCase() + word.slice(1);
		},
		initGraph() {
			const labelsData = [];
			const total = [];
			let criticalQuestionsData = this.criticalQuestionsData.filter(
				(el) => el.failed_count != 0
			);
			criticalQuestionsData = criticalQuestionsData.sort(
				(a, b) => b.failed_count - a.failed_count
			);

			if (criticalQuestionsData.length) {
				criticalQuestionsData.forEach((el) => {
					labelsData.push(
						el.name
							.split(" ")
							.map((word) => this.capitalizeFirstLetter(word))
							.join(" ")
					);
					total.push(el.failed_count);
				});
			}

			this.option.xAxis[0].data = labelsData;
			this.option.series[0].data = total;

			this.byCriticalQuestionsGraphInstance = eCharts.init(
				this.$refs.byCriticalQuestions
			);
			this.byCriticalQuestionsGraphInstance.setOption(this.option);
			this.$forceUpdate();
			setTimeout(() => {
				this.$emit("emitshowGraphbyCriticalQuestion");
			}, 1000);
		},
		getDataByRegion(region) {
			const data = this.criticalQuestionsData.find(
				(el) => el.name.toLowerCase() === region.toLowerCase()
			);
			if (!data) return "";

			let labelTooltip = "";
			let totalValue = "N/A";

			if (this.showScore) {
				labelTooltip = "Completion Score %";
				totalValue = data["completed_score_%"] || "N/A";
			} else if (this.showCompletion) {
				labelTooltip = "Completed %";
				totalValue = data["completion_%"] || "N/A";
			}

			return `
				<div style="display: flex; flex-direction: column; gap: 5px; padding: 5px;">
					<div style="text-transform: capitalize; text-align: center; text-decoration: underline;">${data.name}</div>
					<div style="display: flex; flex-direction: row; justify-content: space-between;">
						<div style="text-align: left;">
							<span style="margin-right:20px">${labelTooltip} :</span>
						</div>
						<div style="text-align: right;">
							<span>${totalValue}%</span>
						</div>
					</div>
				</div>
			`;
		},
	},
};
</script>

<style>
.by-CriticalQuestions {
	height: 300px;
	width: 115% !important;
	margin-left: -80px !important;
}
.by-CriticalQuestions > div {
	background: #ffffff;
	position: relative;
	height: 100%;
	overflow: hidden;
}
</style>
